<script setup>
import { ref, defineProps, defineExpose, onMounted } from 'vue'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
// import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'

// イベント用データ読み込み
import eventdata from "../assets/event.json"

const props = defineProps(['field'])
const field = ref(props.field)

const calendar = ref(null)

const calendarOptions = ref({
  plugins: [
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin // needed for dateClick
  ],
  headerToolbar: {
    left: 'prev,next today',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,timeGridDay'
  },
  buttonText: {
    prev: '<',
    next: '>',
    today: '今日',
    month: '月',
    week: '週',
    day: '日'
  },
  initialView: 'dayGridMonth',
  // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
  navLinks: true,
  businessHours: true,
  editable: true,
  selectable: true,
  selectMirror: true,
  dayMaxEvents: true,
  weekends: true,
  locale: 'ja',
  timeZone: "Asia/Tokyo",
  height: 800,
  // events: eventdata
  dayCellContent: function(arg){
		return arg.date.getDate();
	}
})

onMounted(() => {
  initCalendar();
})

defineExpose({
  reloadCalendar,
});

function initCalendar() {
  let events = eventdata.find(e => e.fieldId === field?.value?.id);
  if (events) {
    const calendarApi = calendar.value.getApi();
    calendarApi.addEventSource(events);
  }
}

function reloadCalendar() {
  const calendarApi = calendar.value.getApi();
  calendarApi.updateSize();
}
</script>

<template>
  <FullCalendar ref="calendar" :options="calendarOptions" />
</template>

<style scoped>
</style>
